<template>
  <div class="page">
    <a-card title="客服设置" :bordered="false" :bodyStyle="{paddingTop:'0px'}"
            :headStyle="{borderBottom:'0px',fontSize:'18px'}">
      <a-form :form="form">
        <a-card :bordered="false" :bodyStyle="{padding:'0px'}" :headStyle="{borderBottom:'0px',padding:'0px'}">
          <a-row slot="title">
            <a-col :span="8">
              <span class="card-title">基本信息</span>
            </a-col>
          </a-row>
          <a-form-item label="客服名称" v-bind="formItemLayout">
            <a-input placeholder="请输入" style="max-width:500px"
                     v-decorator="['customerName', { rules: [{ required: true, message: '请输入客服名称' }] }]"
            />
          </a-form-item>
          <a-form-item label="客服电话" v-bind="formItemLayout">
            <a-input placeholder="请输入" style="max-width:500px"
                     v-decorator="['customerMobile', { rules: [
              { required: true, message: '请输入客服电话' }
              ]}]"
            />
          </a-form-item>
          <a-form-item label="显示设置" v-bind="formItemLayout">
            <a-checkbox-group @change="onChange" v-decorator="['showType']">
              <a-checkbox value="1" disabled>个人中心</a-checkbox>
              <a-checkbox value="2">商品详情</a-checkbox>
            </a-checkbox-group>
          </a-form-item>
        </a-card>
        <a-card :bordered="false" :bodyStyle="{padding:'0px'}" :headStyle="{borderBottom:'0px',padding:'0px'}">
          <a-row slot="title">
            <a-col :span="8">
              <span class="card-title">提示设置</span>
            </a-col>
          </a-row>
          <a-form-item label="子账号订单提醒" :required="true" v-bind="formItemLayout">
            <a-switch
              checked-children="开"
              un-checked-children="关"
              v-decorator="['childAccountOrderSmsReminderSwitch', { valuePropName: 'checked' }]"
            />
            <!--            <a-radio-group v-decorator="['childAccountOrderSmsReminderSwitch']">-->
            <!--              <a-radio :value="1">开启</a-radio>-->
            <!--               <a-radio :value="2">关闭</a-radio>-->
            <!--            </a-radio-group>-->
          </a-form-item>
          <a-form-item v-for="(item, index) in optionsList" :key="index"
                       :label="index === 0 ? '订单短信提醒 ' : ''" :required="true"
                       v-bind="index === 0 ? formItemLayout : formItemLayoutWithOutLabel"
          >
            <a-input v-decorator="[
                `optionsList[${index}].mobile`,
                {
                  validateTrigger: ['change', 'blur'],
                  rules: [
                    {
                      required: true,
                      whitespace: true,
                      message: '请输入手机号',
                    },
                    { pattern: /^1[3456789]\d{9}$/,message: '请输入正确的手机号',}
                  ],
                },
              ]"
                     placeholder="请输入"
                     style="max-width:500px; margin-right: 8px"
            />
            <a-icon v-if="optionsList.length > 1" class="dynamic-delete-button"
                    type="minus-circle-o" :disabled="optionsList.length === 1"
                    @click="() => remove(item,index)"
            />
          </a-form-item>
          <a-form-item v-bind="formItemLayoutWithOutLabel">
            <a-button type="dashed" style="width: 100%;max-width:500px;" @click="add">
              <a-icon type="plus"/>
              手机号
            </a-button>
          </a-form-item>
          <a-form-item v-bind="formItemLayoutWithOutLabel">
            <a-button type="primary" @click="handleSubmit" :loading="submitLoading">保存</a-button>
          </a-form-item>
        </a-card>
      </a-form>
    </a-card>
  </div>
</template>

<script>
import formMixins from '../../../utils/mixins/formMixins'
import { Item } from 'ant-design-vue/es/vc-menu'

export default {
  name: 'ClientService',
  mixins: [formMixins],
  components: {},
  data() {
    return {
      visible: false,
      type: 1,
      optionsList: [{ mobile: '' }],
      merchantId: this.$store.getters.userInfo.merchantId,
      formItemLayoutWithOutLabel: {
        wrapperCol: {
          xxl: { span: 22, offset: 2 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 21, offset: 3 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 20, offset: 4 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 19, offset: 5 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 16, offset: 8 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 14, offset: 10 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      }
    }
  },
  mounted() {
    this.getLogUtils().logWithTag('merchantId', this.$store.getters.userInfo.merchantId)
    this.getCustomerService()
  },
  methods: {
    remove(item, index) {
      this.optionsList = this.optionsList.filter((item, i, a) => i != index)
    },
    add() {
      if (this.optionsList.length < 5) {
        this.optionsList.push({ mobile: '' })
      } else {
        this.$message.error('最多录入5个手机号')
      }
    },
    handleSubmit() {
      this.validateFormParams().then(res => {
        this.getLogUtils().logWithTag(res)
        let params = new Object()
        console.error('=======res=====', res)
        let arr = []
        params.merchantId = this.merchantId
        params.childAccountOrderSmsReminderSwitch = res.childAccountOrderSmsReminderSwitch ? 1 : 2
        params.customerName = res.customerName
        params.customerMobile = res.customerMobile
        params.showType = res.showType.join(',')
        res.optionsList.forEach(item => {
          arr.push(item.mobile)
        })
        params.orderSmsReminderMobileList = arr
        this.getLogUtils().logWithTag('handleSubmit', params)
        this.submitLoading = true
        this.getHttpServices().getUserService().post('merchant/v2/customerService/updateCustomerServiceSet', params)
          .then(res => {
            this.getLogUtils().logWithTag('==handleSubmit==', res)
            this.$message.success('客服设置成功')
          }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
      })
    },
    onChange(checkedValues) {
      this.getLogUtils().logWithTag('checked = ', checkedValues)
    },
    // 获取数据
    getCustomerService() {
      this.getHttpServices().getUserService().post('merchant/v2/customerService/getCustomerServiceSet', {
        merchantId: this.merchantId
      }).then(res => {
        this.getLogUtils().logWithTag('==getCustomerService==', res)
        let arr = res.showType ? res.showType.split(',') : ['1']
        if (res.orderSmsReminderMobileList && res.orderSmsReminderMobileList.length > 0) {
          let mobileList = []
          res.orderSmsReminderMobileList.forEach((item) => {
            let obj = new Object()
            obj.mobile = item
            mobileList.push(obj)
          })
          this.optionsList = mobileList
        } else {
          this.optionsList = [{ mobile: res.customerMobile }]
        }
        this.getLogUtils().logWithTag('this.optionsList = ', JSON.stringify(this.optionsList))
        this.$nextTick(() => {
          this.form.setFieldsValue({
            childAccountOrderSmsReminderSwitch: res.childAccountOrderSmsReminderSwitch === 1,
            customerName: res.customerName,
            customerMobile: res.customerMobile,
            showType: arr,
            optionsList: this.optionsList
          })
        })
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }

}
</script>
<style lang="less">
@import url('../../CustomPage.less');

.heading {
  font-size: 20px;
  font-weight: 400;
  color: #000;
}

.pl10 {
  padding-left: 10px;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}
</style>